export const OUR_STRENGTH = [
    "Proactivity",
    "Belief in our success",
    "Discipline",
    "Efficiency",
    "The desire to constantly improve",
    "A strong team",
]
